import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";
import Arabic from "../../images/arabic title.png";
import { convertToRFT } from "../../utils/convertToRFT";
import { BoxesPacking } from "../features/BoxesPacking";
import WarehousePrint from "./WarehousePrint";
import address from "../../images/arabic address.png";
import { StandardCompanyCodes } from "../features/StandardCompanyCodes";
function StandardPrint({
  billNumber = "",
  customer = "",
  items = "",
  discount = "0",
  discountType = "",
  date = "",
  subTotal = "",
  Total = "",
  paid = "",
  formallyOutstandings = "0",
  saleType = "",
  notes = "",
  printQuote,
  Quote = "",
  fivePercent = "",
  gst = "",
  gstType = "",
  varTotal,
  income = "0",
  further = "0",
  paymentMethod = "cash",
  bankName = "",
  cheque = "",
  currency="PKR",
  company,
}) {
  console.log('discount', discount)
  console.log(' company',  company)

  let doc = new jsPDF();
  const companyCode = localStorage.getItem("companyCode");

  let pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  doc.setFontSize(10);
  const itemsTotalQuantity = items.reduce((acc, curr) => {
    console.log("c", curr.saleQuantity);
    const quantity = acc + Number(curr?.saleQuantity);
    console.log("s", quantity);
    return quantity;
  }, 0);
  console.log("quant", itemsTotalQuantity);
  console.log("items", items);
  console.log("subtotal", subTotal);

  let finalY = "";

  if (companyCode == 7149) {
    let img = new Image();
    let baseUrl = localStorage.getItem("base_url");
    if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
      img = null;
    } else {
      let snapshot = localStorage.getItem("base_url");
      img.src = snapshot;
    }
    if(img) {
      doc.addImage(img, "png", 10, 5, 40, 40);

    }
    doc.setFontSize(22);
    doc.setFontStyle("bold");
    doc.text(localStorage.getItem("company"), pageWidth / 2, 22, {
      align: "center",
    });
    doc.setFontSize(15);
    doc.text(localStorage.getItem("phone") || "", pageWidth / 2, 30, {
      align: "center",
    });
    doc.text("Estimate", pageWidth / 2, 36, {
      align: "center",
    });
    doc.setFontStyle("normal");
    if (printQuote == "true") {
      doc.text("Quotation", 150, 44);
    }

    doc.setFontSize(18);
    doc.setFontStyle("bold");
    doc.text("Customer", 20, 60);
    doc.setFontSize(15);
    doc.text(customer, 20, 70);

    doc.setFontSize(12);

    doc.text("Date", 150, 60);
    doc.text(date, 165, 60);

    doc.text("Bill", 150, 70);
    doc.text(billNumber.toString(), 170, 70);
    doc.text("Cheque No", 150, 75);
    doc.text(cheque.toString(), 170, 75);

    // doc.setFontSize(14);
    // doc.text("Customer", 130, 70);
    // doc.text(customer, 130, 77);
    // doc.setFontSize(12);
    // let address = localStorage.getItem("address") || "";
    // let splitAddress = doc.splitTextToSize(address, 100);

    // doc.text(20, 70, splitAddress);
    jsPDF.autoTableSetDefaults({
      theme: "plain",
      headStyles: { fontStyle: "bold", fontSize: 13 },
      margin: { left: 8, right: 8, bottom: 10 },
      bodyStyles: {
        color: "rgba(0, 0, 0, 0.87)",
        fontStyle: "bold",
        fontSize: 13,
      },
    });
    let col = [];
    col = ["#", "Item", "Qty", "Price", "Total Price"];
    let rows = [];
    items.forEach((item, index) => {
      let bonus = item?.bonus ? item.bonus : 0;
      doc.setFontSize(14);
      let { saleQty, unit, itemPrice, totalPrice } = convertToRFT(
        saleType,
        item,
        "",
        fivePercent
      );

      let saleQtyContent = bonus
        ? `${saleQty + " " + unit}. \n B:${bonus}`
        : saleQty + " " + unit;
      console.log("saleqty", saleQty);

      let temp = [
        index + 1,
        item.name,
        saleQtyContent,
        itemPrice % 1 === 0 ? itemPrice : itemPrice.toFixed(3),
        totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3),
      ];
      rows.push(temp);
    });
    doc.autoTable(col, rows, { startY: 88 });

    finalY = doc.lastAutoTable.finalY;
    doc.setFontStyle("normal");
    doc.cell(20, finalY + 10, 100, 8, " ");
    doc.cell(20, finalY + 18, 100, 30, " ");
    doc.setFontSize(14);
    doc.text("Comments Or Special Instructions", 22, finalY + 16);

    let arrs = "";

    for (let i = 0; i < notes?.length; i++) {
      if ((i + 1) % 30 == 0) {
        arrs = arrs + notes?.charAt(i) + "\n";
      } else {
        arrs = arrs + notes?.charAt(i);
      }
    }
    doc.text(arrs, 22, finalY + 22);

    doc.text("Sub Total", 130, finalY + 13);
    doc.text("Previous Balance", 130, finalY + 20);
    doc.text("Total", 130, finalY + 27);
    doc.text("Paid", 130, finalY + 33);
    doc.text("Balance", 130, finalY + 41);
    let unts = discountType == "price" ? " Rs" : " %";
    let final_tots =
      Total > 0
        ? parseFloat(Total)
        : parseFloat(Total - discount + formallyOutstandings);
    doc.text(
      Number(subTotal) % 1 === 0
        ? Number(subTotal)
        : Number(subTotal).toFixed(3).toString(),
      175,
      finalY + 13
    );
    doc.text(formallyOutstandings.toString(), 175, finalY + 20);
    doc.text(final_tots.toString(), 175, finalY + 27);
    doc.text(paid.toString(), 175, finalY + 33);
    doc.text(parseInt(final_tots - paid).toString(), 175, finalY + 41);
  } else if (companyCode == 6331) {
    let img = new Image();

    let baseUrl = localStorage.getItem("base_url");

    if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
      // let snapshot = employeeLogo;
      // img.src = snapshot;
      img = null

    } else {
      let snapshot = localStorage.getItem("base_url");
      img.src = snapshot;
    }
    doc.setFontSize(14);
    doc.setFontStyle("bold");
    doc.text(localStorage.getItem("company"), pageWidth / 2, 15, {
      align: "center",
    });
    doc.setFontStyle("normal");
    let address = localStorage.getItem("address") || "";
    let phone = localStorage.getItem("phone") || "";
    let splitAddress = doc.splitTextToSize(address, 150);

    let position = 30;
    if (address.length >= 50 && address.length <= 100) {
      position = 35;
    } else if (address.length >= 101 && address.length <= 200) {
      position = 40;
    } else if (address.length >= 201 && address.length <= 300) {
      position = 50;
    }
    doc.setFontSize(12);
    doc.text(splitAddress, pageWidth / 2, 23, {
      align: "center",
    });
    doc.text(phone, pageWidth / 2, position, {
      align: "center",
    });

    doc.setFontSize(14);
    doc.text("Invoice", pageWidth / 2, 50, {
      align: "center",
    });

    doc.setFontStyle("normal");
    if (printQuote == "true") {
      doc.text(Quotation, pageWidth / 2, 22, {
        align: "center",
      });
    }

    doc.setFontSize(10);
    doc.setFontStyle("normal");

    doc.text("Date", 20, 61);
    doc.text(date, 45, 61);
    doc.text("Invoice No.", 20, 68);
    doc.text(billNumber.toString(), 45, 68);

    doc.setFontSize(10);
    doc.text("Customer", 150, 61);
    doc.setFontStyle("normal");
    doc.text(customer, 150, 68);
   if(img){
    doc.addImage(img, "png", 0, 0, 40, 40);

   }
    jsPDF.autoTableSetDefaults({
      theme: "grid",
      headStyles: {
        fontStyle: "bold",
        fillColor: "white",
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },

      margin: { left: 8, right: 8, bottom: 10 },
      bodyStyles: {
        color: [0, 0, 0],
        fontStyle: "bold",
        fontSize: 10,
      },
    });

    let col = [
      "Qty",
      "Description",
      "Batch #",
      "Exp DT",
      "Rate",
      "Disc",
      "Disc Amt",
      "Amount",
    ];

    let rows = [];
    items.forEach((item, index) => {
      let bonus = item?.bonus ? item.bonus : 0;
      doc.setFontSize(10);
      let {
        saleQty,
        unit,
        itemPrice,
        totalPrice,
        itemDiscount,
        discountAmount,
      } = convertToRFT(saleType, item, "", fivePercent);
      let saleQtyContent = bonus
        ? `${saleQty + " " + unit}. \n B:${bonus}`
        : saleQty + " " + unit;
      let temp = [
        {
          content:
            Number(saleQtyContent) % 1 === 0
              ? Number(saleQtyContent)
              : Number(saleQtyContent).toFixed(3), // Applying toFixed(3) to saleQtyContent
          styles: { cellWidth: "auto" },
        },
        item.description,
        item?.batchNo,
        item?.batchExpiry,
        itemPrice,
        itemDiscount + "%",
        discountAmount,
        totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3),
      ];
      rows.push(temp);
    });

    doc.autoTable(col, rows, { startY: 75 });

    finalY = doc.lastAutoTable.finalY;

    doc.text("Sub Total", 130, finalY + 13);
    doc.text("Total", 130, finalY + 18);
    doc.text("Paid", 130, finalY + 23);
    doc.text(
      Number(subTotal) % 1 === 0
        ? Number(subTotal)
        : Number(subTotal).toFixed(3).toString(),
      175,
      finalY + 13
    );

    let final_tots =
      Total > 0
        ? parseFloat(Total)
        : parseFloat(Total - discount + formallyOutstandings);
    doc.text(final_tots.toString(), 175, finalY + 18);
    doc.text(paid.toString(), 175, finalY + 23);

    doc.setFontSize(8);
    doc.setFontStyle("bold");
    doc.text("WARRANTY", 15, finalY + 30);
    doc.setFontStyle("normal");
    doc.text(
      "I being a person resident in Pakistan & carrying on business under the name of HealthCare Innovative Office No A-2, First Floor, Khalifa",
      15,
      finalY + 35
    );
    doc.text(
      "Heights, Committee Chowk, Rawalpindi. As being Whole seller of drug and replying upon warranty of  the manufacturer/his authorized",
      15,
      finalY + 40
    );
    doc.text(
      " agent do hereby give this warranty that the drugs here under described  in this invoice do not contraverse in anyway the provisions",
      15,
      finalY + 45
    );
    doc.text("of section 23 of Drugs Act 1976.", 15, finalY + 50);

    doc.text("Note:", 15, finalY + 57);
    doc.text("i) (*) items are not warranted", 20, finalY + 62);
    doc.text(
      "ii) Expiry must informed before 3 months of expire date",
      20,
      finalY + 67
    );
    doc.text("iii) No leakage, Breakage Accepted", 20, finalY + 72);
    doc.text("Thanks for your business", 15, finalY + 79);
  } else if (companyCode == 9478 || companyCode == 1495) {
    let img = new Image();

    let baseUrl = localStorage.getItem("base_url");

    if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
      // let snapshot = employeeLogo;
      // img.src = snapshot;
      img = null

    } else {
      let snapshot = localStorage.getItem("base_url");
      img.src = snapshot;
    }

    doc.setFontSize(14);
    doc.setFontStyle("bold");

    doc.text(localStorage.getItem("company"), 50, 22);
    doc.setFontStyle("normal");
    if (printQuote == "true") {
      doc.text("Quotation", 150, 22);
    }
    let position = 72;

    doc.setFontSize(14);
    doc.text("BILL DETAIL", 150, 45);

    doc.setFontSize(10);
    doc.setFontStyle("normal");

    doc.text("Date", 150, 53);
    doc.text(date, 175, 53);
    doc.text("Bill", 150, 61);
    doc.text(billNumber.toString(), 175, 61);

    doc.text("Cheque No", 150, 61);
    doc.text(cheque.toString(), 170, 75);

    doc.text("Customer", 105, 61);
    doc.setFontStyle("normal");
    doc.text(customer, 105, 68);

    let address = localStorage.getItem("address") || "";
    let phone = localStorage.getItem("phone") || "";
    let splitAddress = doc.splitTextToSize(address, 50);

    if (address.length >= 50 && address.length <= 100) {
      position = 80;
    } else if (address.length >= 100 && address.length <= 150) {
      position = 85;
    } else if (address.length >= 150 && address.length <= 200) {
      position = 90;
    } else if (address.length >= 200 && address.length <= 250) {
      position = 95;
    }

    doc.text(localStorage.getItem("company") || "", 20, 58);

    doc.text(20, 65, splitAddress);
    doc.text(phone, 20, position);
if(img) {
  doc.addImage(img, "png", 0, 0, 40, 40);

}
    jsPDF.autoTableSetDefaults({
      theme: "grid",
      headStyles: {
        fontStyle: "bold",
        fillColor: "white",
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },

      margin: { left: 8, right: 8, bottom: 10 },
      bodyStyles: {
        color: [0, 0, 0],
        fontStyle: "bold",
      },
    });

    let rows = [];
    let totalGstAmount = 0;

    items.forEach((item, index) => {
      doc.setFontSize(10);
      let { saleQty, itemPrice, totalPrice } = convertToRFT(
        saleType,
        item,
        "",
        fivePercent
      );
      console.log("saleqty", saleQty);
      if (gst && gstType == "Item") {
        console.log("saleqty", saleQty);

        let temp = [
          index + 1,
          item.name,
          saleQty,
          itemPrice % 1 === 0 ? itemPrice : itemPrice.toFixed(3),
          item.gstAmount ? Math.ceil(item.gstAmount) * saleQty : 0,
          (parseInt(totalPrice) + Math.ceil(item.gstAmount) * saleQty).toFixed(
            3
          ),
          totalPrice % 1 === 0
            ? parseInt(totalPrice) + Math.ceil(item.gstAmount) * saleQty
            : (
                parseInt(totalPrice) +
                Math.ceil(item.gstAmount) * saleQty
              ).toFixed(3),
        ];
        if (item?.gstAmount) {
          totalGstAmount += parseInt(item.gstAmount) * saleQty;
        }
        rows.push(temp);
      } else {
        console.log("saleqty", saleQty);

        let temp = [
          index + 1,
          item.name,
          saleQty,
          itemPrice % 1 === 0 ? itemPrice : itemPrice.toFixed(3),
        ];
        // rows.push(temp);
      }
    });

    let col = ["#", "Item", "Qty", "Price"];
    if (gstType == "Item") {
      col = [
        "#",
        "Item",
        "Qty",
        "Price",
        "Sales Tax Payable",
        "Value including sales tax",
      ];
    }

    doc.autoTable(col, rows, { startY: position + 10 });

    finalY = doc.lastAutoTable.finalY;

    doc.cell(20, finalY + 10, 100, 8, " ");
    doc.cell(20, finalY + 18, 100, 30, " ");
    doc.setFontSize(10);
    doc.text("Comments Or Special Instructions", 22, finalY + 16);
    let arrs = "";
    for (let i = 0; i < notes?.length; i++) {
      if ((i + 1) % 30 == 0) {
        arrs = arrs + notes?.charAt(i) + "\n";
      } else {
        arrs = arrs + notes?.charAt(i);
      }
    }
    doc.text(arrs, 22, finalY + 23);

    doc.text("Sub Total", 130, finalY + 13);
    doc.text("GST", 130, finalY + 18);
    doc.text("GST Amount", 130, finalY + 23);
    doc.text("Discount", 130, finalY + 28);
    {
      companyCode == "3687" ? doc.text("Var Total", 130, finalY + 33) : "";
    }

    doc.text("Previous Balance", 130, finalY + 38);
    doc.text("Total", 130, finalY + 43);
    doc.text("Paid", 130, finalY + 48);
    doc.text("Balance", 130, finalY + 53);

    let unts = discountType == "price" ? " Rs" : " %";

    doc.text(
      Number(subTotal) % 1 === 0
        ? Number(subTotal)
        : Number(subTotal).toFixed(3).toString(),
      175,
      finalY + 13
    );

    let totalGst = 0;

    if (gst && gstType == "Bill") {
      if (subTotal) {
        let gstAmount = parseInt(
          (parseInt(gst) / 100) *
            doc.text(
              Number(subTotal) % 1 === 0
                ? Number(subTotal)
                : Number(subTotal).toFixed(3).toString(),
              175,
              finalY + 13
            )
        );
        totalGst = gstAmount || 0;
      } else {
        totalGst = 0;
      }
    } else if (gst && gstType == "Item") {
      totalGst = totalGstAmount;
    } else {
      totalGst = 0;
    }

    doc.text(gst ? `${gst}%` : "-", 175, finalY + 18);
    doc.text(totalGst.toString() || "-", 175, finalY + 23);

    doc.text(
      discount ? discount.toString() + " " + unts : +"0 " + unts,
      175,
      finalY + 28
    );

    doc.text(formallyOutstandings.toString(), 175, finalY + 33);
    let final_tots =
      Total > 0
        ? parseFloat(Total)
        : parseFloat(Total - discount + formallyOutstandings);
    doc.text(parseInt(final_tots).toString(), 175, finalY + 38);
    doc.text(paid.toString(), 175, finalY + 43);
    doc.text(parseInt(final_tots - paid).toString(), 175, finalY + 48);
  } else {
    let img = new Image();

    let baseUrl = localStorage.getItem("base_url");

    if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
      img = null
    } else {
      let snapshot = localStorage.getItem("base_url");
      img.src = snapshot;
    }

    doc.setFontSize(14);
    doc.setFontStyle("bold");
    if (companyCode == 4971) {
      let title = new Image();
      title.src = Arabic;
      doc.addImage(title, "png", 50, 6, 150, 20);
    } else {
      if (companyCode == "3687") {
        doc.setFontSize(18);

        doc.text(localStorage.getItem("company"), 62, 52);
      } else {
        if (companyCode == "4326") {
          doc.setFontSize(24);

          doc.text(localStorage.getItem("company"), 70, 22);
        } else if (companyCode !== "2821") {
          doc.text(localStorage.getItem("company"), 50, 22);
        }
      }
    }
    doc.setFontStyle("normal");
    if (printQuote == "true") {
      if (companyCode == "3687") {
        doc.text("Quotation", 90, 60);
      } else {
        if (companyCode !== "2821") {
          doc.text("Quotation", 150, 22);
        }
      }
    }
    let position = 72;
    if (companyCode == "197") {
      doc.setFontSize(10);
      doc.text("Customer", 20, 53);
      doc.setFontStyle("normal");
      doc.text(customer, 20, 61);
      doc.text("Date", 90, 53);
      doc.text(date, 115, 53);
      doc.text("Invoice No.", 90, 61);
      doc.text(billNumber.toString(), 115, 61);
    } else {
      if (companyCode == "3687") {
        doc.setFontSize(14);
        // doc.text("BILL DETAIL", 150, 45);

        doc.setFontSize(10);
        doc.setFontStyle("normal");

        doc.text("Date", 168, 70);
        doc.text(date, 180, 70);
        doc.text("Bill", 150, 70);
        doc.text(billNumber.toString(), 158, 70);

        doc.text("Cheque No", 150, 75);
        doc.text(cheque.toString(), 170, 75);

        doc.text("Customer", 150, 65);
        doc.setFontStyle("normal");
        doc.text(customer, 175, 65);
      } else {
        doc.setFontSize(14);
        // doc.text("BILL DETAIL", 150, 45);
        if (companyCode !== "2821") {
          doc.text("BILL DETAIL", 150, 45);
        }

        doc.setFontSize(10);
        doc.setFontStyle("normal");

        doc.text("Date", 150, 53);
        doc.text(date, 175, 53);
        doc.text("Bill", 150, 61);
        doc.text(billNumber.toString(), 175, 61);

        doc.text("Cheque No", 150, 68);
        doc.text(cheque.toString(), 175, 68);

        doc.text("Customer", 105, 61);
        doc.setFontStyle("normal");
        doc.text(customer, 105, 68);
      }

      if (companyCode == 4971) {
        let title = new Image();
        title.src = address;
        doc.text("Darb public street next to Abu Qarn Station", 20, 65);
        doc.addImage(title, "png", 20, 66, 80, 5);
        doc.text(localStorage.getItem("phone") || "", 20, 80);
      } else {
        let address = localStorage.getItem("address") || "";
        let phone = localStorage.getItem("phone") || "";
        let phone1 = localStorage.getItem("p1") || "";
        let phone2 = localStorage.getItem("p2") || "";

        let splitAddress = doc.splitTextToSize(address, 50);

        if (address.length >= 50 && address.length <= 100) {
          position = 80;
        } else if (address.length >= 100 && address.length <= 150) {
          position = 85;
        } else if (address.length >= 150 && address.length <= 200) {
          position = 90;
        } else if (address.length >= 200 && address.length <= 250) {
          position = 95;
        }

        // doc.text(localStorage.getItem("company") || "", 20, 58);
        if (companyCode == "3687") {
          let addressPosition = 70;
          if (address.length >= 30 && address.length <= 100) {
            addressPosition = 73;
          } else if (address.length >= 101 && address.length <= 200) {
            addressPosition = 80;
          }
          doc.text(12, 65, splitAddress);
          doc.text("Phone No", 12, addressPosition);
          // doc.text(phone, 15, addressPosition);
          doc.text(phone1, 32, addressPosition);
          doc.text(phone2, 57, addressPosition);
        } else {
          doc.text(localStorage.getItem("company") || "", 20, 58);
          doc.text(20, 65, splitAddress);
          doc.text(phone, 20, position);
          doc.text(phone1, 20, 72);
          doc.text(phone2, 20, 77);
        }
      }
    }
    if (companyCode == "3687") {
      doc.addImage(img, "png", 80, 0, 40, 40);
    } else {
      if (companyCode !== "2821") {
        if(img) {
          doc.addImage(img, "png", 0, 0, 40, 40);

        }
      }
    }
    jsPDF.autoTableSetDefaults({
      theme: "grid",
      headStyles: {
        fontStyle: "bold",
        fillColor: "white",
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },

      margin: { left: 8, right: 8, bottom: 10 },
      bodyStyles: {
        color: [0, 0, 0],
        fontStyle: "bold",
      },
    });

    let col = [];
    if (BoxesPacking()) {
      col = ["#", "Item", "Description", "Qty", "Box", "Price", "Total Price"];
    } else {
      if (companyCode == "197") {
        col = [
          "#",
          "Item",
          "Qty",
          "Price",
          "Disc",
          "Disc Amount",
          "Total Price",
        ];
      } else {
        if (companyCode == "3687") {
          col = ["#", "Item", "Qty", "Price", "Disc", "Total Price"];
        } else if (companyCode == "4326") {
          col = [
            "#",
            "Item",
            "Description",
            "Qty",
            "Price",
            "Disc",
            "Disc Amount",
            "Total Price",
          ];
        } else if (companyCode == "8701") {
          col = [
            "#",
            "Item",
            "Qty",
            "Price",
            "Disc",
            "Disc Amount",
            "Total Price",
          ];
        } else if (companyCode == "7225") {
          col = [
            "#",
            "Item",
            "Qty",
            "Price",
            "Total Price",
          ];
        } else {
          col = [
            "#",
            "Item",
           company.imeiNumberShow == "yes" ?  "Imei Number" : "Description",
            "Unit",
            "Qty",
            "Price",
            "Disc",
            "Disc Amount",
            "Total Price",
          ];
        }
      }
    }
    let rows = [];
    items.forEach((item, index) => {
      let bonus = item?.bonus ? item.bonus : 0;
      doc.setFontSize(10);
      let {
        saleQty,
        unit,
        itemPrice,
        totalPrice,
        itemDiscount,
        discountAmount,
      } = convertToRFT(saleType, item, "", fivePercent);
      let saleQtyContent = bonus
        ? `${saleQty + " " + unit}. \n B:${bonus}`
        : saleQty + " " + unit;
      let boxes = 0;
      if (BoxesPacking()) {
        if (saleQty && item?.packing) {
          let totalBox = parseFloat(saleQty) / item.packing;
          boxes = totalBox % 1 === 0 ? totalBox : totalBox.toFixed(2);
        } else {
          boxes = 0;
        }
        let temp = [
          console.log("saleqty", saleQty),
          index + 1,
          item.name,
          item.description,
          unit,
          {
            content:
              Number(saleQtyContent) % 1 === 0
                ? Number(saleQtyContent)
                : Number(saleQtyContent).toFixed(3),
            // Applying toFixed(3) to saleQtyContent
            styles: { cellWidth: "auto" },
          },
          boxes,
          discountAmount,
          totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3),
        ];
        rows.push(temp);
      } else {
        if (companyCode == "197") {
          console.log("saleqty", saleQty);

          let temp = [
            index + 1,
            item.name,
            { content: saleQtyContent, styles: { cellWidth: "auto" } },
            itemPrice % 1 === 0 ? itemPrice : itemPrice.toFixed(3),
            itemDiscount + "%",
            discountAmount,
            totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3),
          ];
          rows.push(temp);
        } else {
          if (companyCode == "3687") {
            console.log("saleqty", saleQty);

            let temp = [
              index + 1,
              item.name,
              { content: saleQtyContent, styles: { cellWidth: "auto" } },
              itemPrice % 1 === 0 ? itemPrice : itemPrice.toFixed(3),
               itemDiscount + "%",
              totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3),
            ];
            rows.push(temp);
            doc.autoTable(col, rows, {
              startY: 100,
            });
          } else {
            console.log("saleqty", saleQty);
            let temp;
            if (companyCode == "4326") {
              temp = [
                index + 1,
                item.name,
                item.description,
                {
                  content:
                    Number(saleQty) % 1 === 0
                      ? Number(saleQty)
                      : Number(saleQty).toFixed(3), // Applying toFixed(3) to saleQtyContent
                  styles: { cellWidth: "auto" },
                },
                itemPrice % 1 === 0 ? itemPrice : itemPrice.toFixed(3),
                itemDiscount + "%",
                discountAmount,
                totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3),
              ];
            } else if (companyCode == "8701") {
              temp = [
                index + 1,
                item.name,

                //  unit,
                {
                  content:
                    Number(saleQty) % 1 === 0
                      ? Number(saleQty)
                      : Number(saleQty).toFixed(3), // Applying toFixed(3) to saleQtyContent
                  styles: { cellWidth: "auto" },
                },
                itemPrice % 1 === 0 ? itemPrice : itemPrice.toFixed(3),
                itemDiscount + "%",
                discountAmount,
                totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3),
              ];
            } else if (companyCode == "7225") {
              temp = [
                index + 1,
                item.name,
                {
                  content:
                    Number(saleQty) % 1 === 0
                      ? Number(saleQty)
                      : Number(saleQty).toFixed(3), // Applying toFixed(3) to saleQtyContent
                  styles: { cellWidth: "auto" },
                },
                itemPrice % 1 === 0 ? itemPrice : itemPrice.toFixed(3),
                totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3),
              ];
            }  else {
              temp = [
                index + 1,
                item.name,
                company.imeiNumberShow == "yes" ?  item?.imeiNumber : item.description,

                unit,
                {
                  content:
                    Number(saleQty) % 1 === 0
                      ? Number(saleQty)
                      : Number(saleQty).toFixed(3), // Applying toFixed(3) to saleQtyContent
                  styles: { cellWidth: "auto" },
                },
                itemPrice % 1 === 0 ? itemPrice : itemPrice.toFixed(3),
                itemDiscount + "%",
                discountAmount,
                totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3),
              ];
            }

            rows.push(temp);
            doc.autoTable(col, rows, { startY: position + 10 });
          }
        }
      }
    });

    finalY = doc.lastAutoTable.finalY;
    let previousPositon;
    let totalPosition;
    let totalPaid;
    let totalBalance;

    if (companyCode == "3687") {
      previousPositon = companyCode == "1916" ? finalY + 33 : finalY + 58;

      totalPosition = companyCode == "1916" ? finalY + 38 : finalY + 63;
      totalPaid = companyCode == "1916" ? finalY + 43 : finalY + 68;
      totalBalance = companyCode == "1916" ? finalY + 48 : finalY + 73;
    } else if (companyCode == "4326") {
      totalPosition = finalY + 18;
      totalPaid = finalY + 23;
      totalBalance = finalY + 28;
    }else if (companyCode == "7225") {
      previousPositon = finalY + 18;
      totalPosition = finalY + 23;
      totalPaid = finalY + 28;
      totalBalance = finalY + 33;
    }  else {
      previousPositon = companyCode == "1916" ? finalY + 43 : finalY + 38;

      totalPosition = companyCode == "1916" ? finalY + 48 : finalY + 43;
      totalPaid = companyCode == "1916" ? finalY + 53 : finalY + 48;
      totalBalance = companyCode == "1916" ? finalY + 58 : finalY + 53;
    }

    if (companyCode == "197") {
      doc.setFontSize(10);
    } else {
      if (companyCode == "3687") {
        doc.cell(20, finalY + 40, 100, 8, " ");
        doc.cell(20, finalY + 48, 100, 30, " ");
        doc.setFontSize(10);
        doc.text("Comments Or Special Instructions", 22, finalY + 46);
        let arrs = "";
        for (let i = 0; i < notes?.length; i++) {
          if ((i + 1) % 30 == 0) {
            arrs = arrs + notes?.charAt(i) + "\n";
          } else {
            arrs = arrs + notes?.charAt(i);
          }
        }
        doc.text(arrs, 22, finalY + 23);
      } else {
        if (companyCode !== "4326") {
          doc.cell(20, finalY + 10, 100, 8, " ");
          doc.setFontSize(10);
          doc.text("Comments Or Special Instructions", 22, finalY + 16);
        }

        let arrs = "";
        for (let i = 0; i < notes?.length; i++) {
          if(notes.length > 200) {
            doc.cell(20, finalY + 18, 100, 100, " ");

          } else if (notes.length < 200 ){
            doc.cell(20, finalY + 18, 100, 30, " ");

          }


          if ((i + 1) % 50 == 0) {

            arrs = arrs + notes?.charAt(i) + "\n";
          } else {

            arrs = arrs + notes?.charAt(i);
          }
        }

        if(!notes){
          doc.cell(20, finalY + 18, 100, 30, " ");

        }

        doc.text(arrs, 22, finalY + 23);
      }
    }

    if (companyCode == "197") {
      doc.text("Sub Total", 130, finalY + 13);
      doc.text("GST", 130, finalY + 18);
      doc.text("Discount", 130, finalY + 23);
      doc.text("Total", 130, finalY + 28);
      doc.text("Paid", 130, finalY + 33);
      doc.text("Balance", 130, finalY + 38);
    } else {
      if (companyCode == "3687") {
        doc.text("Sub Total", 130, finalY + 43);
        doc.text("GST", 130, finalY + 48);
        // doc.text("Discount", 130, finalY + 53);
      } else if (companyCode == "4326") {
        doc.text("Sub Total", 130, finalY + 13);
      } else {
        doc.text("Sub Total", 130, finalY + 13);
        if(companyCode !== "7225") {
        doc.text("GST", 130, finalY + 18);
        doc.text("IT", 130, finalY + 23);
        doc.text("FT", 130, finalY + 28);
        doc.text("Discount", 130, finalY + 33);
        }
      }

      if (companyCode == "1916") {
        doc.text("Var Total", 130, finalY + 38);
      }
      if (companyCode == "3687") {
        doc.text("Previous Balance", 130, previousPositon - 5);

        doc.text("Total", 130, totalPosition - 5);

        doc.text("Paid", 130, totalPaid - 5);

        doc.text("Balance", 130, totalBalance - 5);
      } else if (companyCode == "4326") {
        doc.text("Total", 130, totalPosition);

        doc.text("Paid", 130, totalPaid);

        doc.text("Balance", 130, totalBalance);
      }  else if (companyCode == "7225") {
        doc.text("Previous Balance", 130,  previousPositon );

        doc.text("Total", 130, totalPosition );

        doc.text("Received", 130, totalPaid);

        doc.text("Remaining Balance", 130, totalBalance);
        doc.text(formallyOutstandings.toString(),175, previousPositon);

        let final_tots =
          Total > 0
            ? parseFloat(Total)
            : parseFloat(Total - discount + formallyOutstandings);
        doc.text(
          final_tots % 1 === 0
            ? `${final_tots.toString()} ${currency}`
            : `${final_tots.toFixed(3).toString()} ${currency}`,
          175,
          totalPosition
        );
      
        doc.text(paid.toString(), 175, totalPaid);
        doc.text(
          final_tots % 1 === 0
            ? `${Number(final_tots - paid).toString()} ${currency}`
            : `${ Number(final_tots - paid)
            .toFixed(3)
            .toString()} ${currency}`,
          175,
          totalBalance
        );
      } 
      else if (companyCode !== "7225")  {
        doc.text("Previous Balance", 130, previousPositon);

        doc.text("Total", 130, totalPosition);
        doc.text("Received", 130, totalPaid);
        doc.text(
          Number(discount).toString(),
          175,
          finalY + 33
        );
        doc.text(
          Number(paid) > Number(Total) ? "Change" : "Remaining Balance",
          130,
          totalBalance
        );
        if(companyCode !== "7225") {
          doc.text("Total Quantity", 130, totalBalance + 5);
          doc.text("Payment Method", 130, totalBalance + 10);
          if (paymentMethod == "bank") {
            doc.text("Bank", 130, totalBalance + 15);
          }
        }
      
      }
    }
    let unts =
      companyCode == "1916" ? "AED" : discountType == "price" ? " Rs" : " %";

    if (companyCode == "3687") {
      doc.text(
        Number(subTotal) % 1 === 0
          ? Number(subTotal).toString()
          : Number(subTotal).toFixed(3).toString(),
        175,
        finalY + 43
      );
    } else {
      doc.text(
        Number(subTotal) % 1 === 0
          ? Number(subTotal).toString()
          : Number(subTotal).toFixed(3).toString(),
        175,
        finalY + 13
      );
    }

    let gstStatus = "";

    if (gst) {
      if (gst == "disabled") {
        gstStatus = "0";
      } else {
        gstStatus = gst;
      }
    } else {
      gstStatus = "0";
    }
    if (companyCode == "3687") {
      doc.text(gstStatus + "%" || "", 175, finalY + 48);
    } else if (companyCode !== "4326" && companyCode !== "7225" ) {
      doc.text(gstStatus + "%" || "", 175, finalY + 18);
    }

    if (companyCode == "3687") {
      // doc.text(
      //   discount ? discount.toString() + " " + unts : +"0 " + unts,
      //   175,
      //   finalY + 53
      // );
    } else {
      if (companyCode !== "2821") {
        if(img) {
          doc.addImage(img, "png", 0, 0, 40, 40);

        }
      } else if (companyCode !== "4326") {
        doc.text(income + "%" || "", 175, finalY + 23);
        doc.text(further + "%" || "", 175, finalY + 28);

        doc.text(
          discount ? discount.toString() + " " + unts : +"0 " + unts,
          175,
          finalY + 33
        );
      }
    }

    if (companyCode == "197") {
      let final_tots =
        Total > 0 ? parseFloat(Total) : parseFloat(Total - discount);
      doc.text(final_tots.toString(), 175, previousPositon);
      doc.text(paid.toString(), 175, totalPaid);
      doc.text(parseInt(final_tots - paid).toString(), 175, totalBalance);
    } else {
      {
        companyCode === "1916" &&
          doc.text((varTotal ?? 0).toString(), 175, finalY + 28);
      }

      if (companyCode == "3687") {
        const previousPositon =
          companyCode == "1916" ? finalY + 33 : finalY + 58;

        const totalPosition = companyCode == "1916" ? finalY + 38 : finalY + 63;
        const totalPaid = companyCode == "1916" ? finalY + 43 : finalY + 68;
        const totalBalance = companyCode == "1916" ? finalY + 48 : finalY + 73;
      } else {
        const previousPositon =
          companyCode == "1916" ? finalY + 33 : finalY + 28;

        const totalPosition = companyCode == "1916" ? finalY + 38 : finalY + 33;
        const totalPaid = companyCode == "1916" ? finalY + 43 : finalY + 38;
        const totalBalance = companyCode == "1916" ? finalY + 48 : finalY + 43;
      }

      if (companyCode == "3687") {
        doc.text(formallyOutstandings.toString(), 175, previousPositon - 5);
        let final_tots =
          Total > 0
            ? parseFloat(Total)
            : parseFloat(Total - discount + formallyOutstandings);
        doc.text(final_tots.toString(), 175, totalPosition - 5);
        doc.text(paid.toString(), 175, totalPaid - 5);
        doc.text(Number(final_tots - paid).toString(), 175, totalBalance - 5);
      } else if (companyCode == "4326") {
        let final_tots =
          Total > 0
            ? parseFloat(Total)
            : parseFloat(Total - discount + formallyOutstandings);
        doc.text(
          final_tots % 1 === 0
            ? final_tots.toString()
            : final_tots.toFixed(3).toString(),
          175,
          totalPosition
        );
        doc.text(paid.toString(), 175, totalPaid);
        doc.text(
          final_tots % 1 === 0
            ? Number(final_tots - paid).toString()
            : Number(final_tots - paid)
                .toFixed(3)
                .toString(),
          175,
          totalBalance
        );
      } 
        else if (companyCode !== "7225"){
        doc.text(formallyOutstandings.toString(), 175, previousPositon);
        let final_tots =
          Total > 0
            ? parseFloat(Total)
            : parseFloat(Total - discount + formallyOutstandings);
        doc.text(
          final_tots % 1 === 0
            ? `${final_tots.toString()} ${currency}`
            : `${final_tots.toFixed(3).toString()} ${currency}`,
          175,
          totalPosition
        );
      
        doc.text(paid.toString(), 175, totalPaid);
        doc.text(
          final_tots % 1 === 0
            ? `${Number(final_tots - paid).toString()} ${currency}`
            : `${ Number(final_tots - paid)
            .toFixed(3)
            .toString()} ${currency}`,
          175,
          totalBalance
        );
        doc.text(
          itemsTotalQuantity % 1 === 0
            ? itemsTotalQuantity.toString()
            : itemsTotalQuantity.toFixed(3).toString(),
          175,
          totalPaid + 10
        );
        const capitalizeFirstLetter = (str) => {
          return str.charAt(0).toUpperCase() + str.slice(1);
        };
        doc.text(
          capitalizeFirstLetter(paymentMethod.toString()),
          175,
          totalPaid + 15
        );
        doc.text(
          capitalizeFirstLetter(bankName.toString()),
          175,
          totalPaid + 20
        );
      }
    }
  }

  let imgStamp = new Image();


  if (company?.billStamp?.url == undefined || company?.billStamp?.url == "" || company?.billStamp?.url == null) {
    imgStamp = null;
  } else {
    imgStamp.src = company?.billStamp?.url;
  }
  if(imgStamp) {
    doc.addImage(imgStamp, "png", 150, 200, 40, 40);

  }
  // doc.setFontSize(8);
  // doc.text("Powered by www.managekaro.pk", 84, 285);
  // doc.text("0331 5921209", 95, 290);

  let temp = localStorage.getItem("template");
  if (Quote == "Quotation") {
    doc.setFontSize(10);
    if (window.innerWidth <= 600) {
      doc.save("reciept");
    } else {
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");
    }
  } else {
    if (temp == null || temp == "standard") {
      doc.setFontSize(10);
      if (window.innerWidth <= 600) {
        doc.save("reciept");
      } else {
        doc.autoPrint();
        window.open(doc.output("bloburl"), "_blank");
      }
    } else if (temp == "standard_warehouse") {
      doc.addPage();
      WarehousePrint(billNumber, customer, items, date, notes, doc, temp);
    } else if (temp == "three_copies") {
      doc.addPage();
      WarehousePrint(billNumber, customer, items, date, notes, doc, temp);
    }
  }
}

export default StandardPrint;
